import { cva, type VariantProps } from 'class-variance-authority';

export const listVariants = cva('flex flex-col gap-xxs', {
  variants: {
    bulletStyle: {
      none: 'list-none',
      bullet: 'list-disc pl-6 marker:text-primary-700',
      square: 'list-square pl-6 marker:text-neutral-500',
      check: 'list-none',
    },
  },
  defaultVariants: {
    bulletStyle: 'check',
  },
});

export const listItemVariants = cva('font-body text-b4 leading-b4');

export type ListVariantProps = VariantProps<typeof listVariants>;
